import React from "react";
import ProductPriceFormat from "../../products/product-price/product-price-format";
import {useAppSelector} from "../DAL/store";
import TimerCountDown from "../../../ui/clock/count-down-timer/count-down-timer";
import {SubscriptionPlanModel} from "../interfaces";
import {getTimerCounterDataFromHtml} from "../../../ui/clock/clock-provider";

interface IPriceProps {
    plan:SubscriptionPlanModel,
    isStarter:boolean,
    isAnnual?:boolean,
    isPopup?:boolean,
    showCounter?:boolean
}

const TIMER_ID = "subscription-timer-2";

export const PriceDifferent = (props: IPriceProps) => {
    //console.log('PriceDifferent', props);

    const timerFromHtml = getTimerCounterDataFromHtml(TIMER_ID);
    let IsAnnual =  useAppSelector((store) => store.IsAnnual);
    if(props.isAnnual !== undefined){
        IsAnnual = props.isAnnual;
    }
    return (
        <>
            {
                !IsAnnual &&
                <span><ProductPriceFormat price={props.plan.skU_MSRP}/><span
                    className="text-base font-normal"> / month</span></span>
            }
            {
                IsAnnual &&
                <div className="flex items-center justify-center">
                    <div className="w-fit">
                        {timerFromHtml && props?.showCounter &&
                            <div className="timer-container mb-4">
                                <div className="text-2xl font-bold text-yellow-400">
                                    <span className="text-white pr-1">Limited Time:</span>
                                    <TimerCountDown
                                        expiredWhenNumber={0}
                                        timerType=""
                                        loadDataFromHtml={TIMER_ID}
                                    />
                                </div>
                            </div>
                        }
                        {
                            !timerFromHtml && props?.showCounter &&
                            <div className="text-2xl md:text-2xl xl:text-3xl mb-4 text-yellow-400 font-bold">
                                Black Friday Sale
                            </div>
                        }
                        <div className="text-xl font-normal line-through"><ProductPriceFormat
                            price={props.plan.skU_MSRP}/>/ year
                        </div>
                        <div className=""><ProductPriceFormat price={props.plan.skuPrice}/></div>
                        <div className="text-xl font-normal">for the first year</div>
                    </div>
                </div>
            }
        </>
    )
};